import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { EntryModule } from "@/store/modules/entry.module";
import EcGrid from "@/components/widgets/EcGrid.vue";
import entryListingMachineMachine from "./machines/entryListingMachine";
import { interpret } from "xstate";
import DeleteComponent from "@/components/deleteComponent.vue";
import EcSelect from "@/components/widgets/EcSelect.vue";
import { GuidItemModel } from "@/store/models/shared/guidItem";
import Switches from "vue-switches";
import { SettingModule } from "@/store/modules/settings.module";
import AdvanceSearchComponent from "./components/AdvanceSearchComponent.vue";
import { EntryAdvanceSearchModel } from "@/store/models/entry/entryAdvanceSearchDTO";
import { EntrySearchOptionsModel } from "@/store/models/entry/entrySearchOptionsDTO";
import { EntryReportModel } from "@/store/models/entry/entryExportDTO";
import EntryReportComponent from "./components/EntryReportComponent.vue";
import simplebar from "simplebar-vue";
import { EntrySaveSearchModel } from "@/store/models/entry/entrySaveSearchDTO";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { FileUploadModule } from "@/store/modules/fileUpload.module";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import RejectEntryComponent from "./components/RejectEntryComponent.vue";
/**
 * EntryListing Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let EntryListing = /** @class */ (() => {
    let EntryListing = class EntryListing extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.title = "Entries";
            this.totalCount = 0;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.entries = [];
            this.showFavorites = false;
            this.modalTitle = "";
            this.genericReportId = "2033b734-4bae-45d5-a5b3-3a27ff05d2f5";
            this.entrySearch = new EntryAdvanceSearchModel();
            this.entriesSelected = new EntrySearchOptionsModel();
            this.reportItems = new EntryReportModel();
            this.saveSearchItem = new EntrySaveSearchModel();
            this.selectedSearch = new EntrySaveSearchModel();
            this.rejectEntryReason = new GuidItemModel();
            this.searchId = "";
            this.rejectEntryId = "";
            this.initialSortBy = {
                field: "actionDate",
                type: "desc",
            };
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Entries",
                    active: true,
                },
            ];
            // machines
            this.machine = entryListingMachineMachine.withContext({
                searchData: {
                    page: 1,
                    pageSize: 10,
                    sort: {
                        field: "actionDate",
                        type: "desc",
                    },
                    columnFilters: [],
                    columnListFilters: [],
                },
                reportName: "",
                entriesCount: 0,
                isPageChanged: false,
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
            this.columnListFilters = ([] = []);
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "actionDate",
                    type: "desc",
                },
                page: 1,
                pageSize: 10,
            };
            this.columns = [
                {
                    label: "",
                    field: "btn",
                    html: true,
                    sortable: false,
                    thClass: "entry-row-select",
                    tdClass: "no-row-click",
                },
                {
                    field: "status",
                    label: "Status",
                    thClass: "col-size-130",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "referenceNumber",
                    label: "Reference No.",
                    thClass: "col-refno",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Enter Reference Number",
                        autoComplete: "off",
                    },
                },
                {
                    field: "state",
                    label: "State",
                    thClass: "col-state",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "description",
                    label: "Description",
                    thClass: "col-size-md text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "whyItMatters",
                    label: "Why It Matters",
                    thClass: "col-size-130 text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "mostRecentAction",
                    label: "Recent Action",
                    thClass: "col-size-md text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "upcomingEvents",
                    label: "Upcoming",
                    thClass: "col-size-md text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "actionDate",
                    label: "Recent Action Date",
                    thClass: "col-size-lg",
                    tdClass: "",
                    sortable: true,
                },
                {
                    field: "type",
                    label: "Type",
                    thClass: "col-size-md",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "categories",
                    label: "Categories",
                    thClass: "col-size-lg",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "tags",
                    label: "Report Tags",
                    thClass: "col-size-lg",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "col-size-sm",
                    tdClass: "no-row-click",
                    sortable: false,
                },
            ];
            this.clientColumns = [
                {
                    label: "",
                    field: "btn",
                    html: true,
                    sortable: false,
                    thClass: "entry-row-select",
                    tdClass: "no-row-click",
                },
                {
                    field: "status",
                    label: "Status",
                    thClass: "col-size-130",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "referenceNumber",
                    label: "Reference No.",
                    thClass: "col-refno",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Enter Reference Number",
                        autoComplete: "off",
                    },
                },
                {
                    field: "state",
                    label: "State",
                    thClass: "col-state",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "description",
                    label: "Description",
                    thClass: "col-size-md text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "whyItMatters",
                    label: "Why It Matters",
                    thClass: "col-size-130 text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "mostRecentAction",
                    label: "Recent Action",
                    thClass: "col-size-md text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "upcomingEvents",
                    label: "Upcoming",
                    thClass: "col-size-md text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "actionDate",
                    label: "Recent Action Date",
                    thClass: "col-size-lg",
                    sortable: true,
                },
                {
                    field: "type",
                    label: "Type",
                    thClass: "col-size-md",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "categories",
                    label: "Categories",
                    thClass: "col-size-lg",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
            ];
        }
        send(event) {
            this.machineService.send(event);
        }
        // METHODS
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            var filters = [];
            var listfilters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            if (this.columnListFilters != null) {
                Object.entries(this.columnListFilters).forEach(([key, value]) => {
                    listfilters.push({
                        listname: key,
                        listvalue: value,
                    });
                });
            }
            filters.push({
                name: "favorites",
                value: `${this.showFavorites}`,
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
                columnListFilters: listfilters,
            };
            EntryModule.AssignParams(searchData);
            this.saveSearchItem.entrySearch = searchData;
            this.machineService.send({
                type: "GETTING_ENTRIES",
                searchData: searchData,
            });
        }
        get rows() {
            return EntryModule.entries;
        }
        get selectedEntries() {
            var selectedEntries = this.$refs.ecgrid;
            return selectedEntries.$refs.grid.selectedRows;
        }
        get isAllSelected() {
            var selectedEntries = this.$refs.ecgrid;
            return selectedEntries.$refs.grid.allSelected;
        }
        get totalEntries() {
            return EntryModule.totalCount;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get status() {
            return EntryModule.statuses.map((x) => ({ value: x.id, text: x.value }));
        }
        get types() {
            return EntryModule.types.map((x) => ({ value: x.id, text: x.value }));
        }
        get states() {
            return EntryModule.states.map((x) => ({ value: x.id, text: x.value }));
        }
        get tags() {
            return EntryModule.tags.map((x) => ({ value: x.id, text: x.value }));
        }
        get categories() {
            return EntryModule.categories.map((x) => ({ value: x.id, text: x.value }));
        }
        get entryAdvanceSearchData() {
            return EntryModule.entryAdvanceSearchData;
        }
        get searches() {
            return EntryModule.searches;
        }
        onRowClick(params) {
            var node = params.event.target.nodeName;
            var nodeClass = params.event.target.className;
            if (node != "INPUT" && node != "A" && node != "BUTTON" && nodeClass != "vgt-checkbox-col" && nodeClass != "vgt-left-align no-row-click" && nodeClass != "no-row-click") {
                this.$router.push({
                    name: "ViewEntry",
                    params: { entryId: params.row.id },
                });
            }
        }
        ViewEntry(params) {
            this.$router.push({ name: "ViewEntry", params: { entryId: params.id } });
        }
        clearFilter() {
            this.searchId = "";
            this.selectedSearch = new EntrySaveSearchModel();
            this.serverParams.columnFilters = {};
            this.serverParams.columnListFilters = {};
            this.showFavorites = false;
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        get isAdmin() {
            return SettingModule.userRole == this.admin;
        }
        get isAnalyst() {
            return SettingModule.userRole == this.analyst;
        }
        get isClient() {
            return SettingModule.userRole == this.client;
        }
        get columnsFields() {
            return this.isClient ? this.clientColumns : this.columns;
        }
        get isLastpage() {
            return this.totalCount - this.serverParams.pageSize * (this.serverParams.page - 1) == this.rows.length;
        }
        refNoTootipMsg(value) {
            return value.length > 24 ? value : null;
        }
        assignEntry(id) {
            this.entries = [];
            this.entries.push(id);
        }
        showFavoriteEntries() {
            this.serverParams.columnFilters = {};
            this.serverParams.page = 1;
            this.loadItems();
        }
        markAsFavorite(id) {
            const entry = this.rows.find((y) => y.id == id);
            if (this.showFavorites) {
                this.machineService.send({
                    type: "FAVORITE_ENTRY_WITH_RELOAD",
                    entryId: id,
                    isFavorite: !entry.isFavorite,
                });
            }
            else {
                this.machineService.send({
                    type: "FAVORITE_ENTRY",
                    entryId: id,
                    isFavorite: !entry.isFavorite,
                });
            }
        }
        showArchiveEntries(id) {
            this.modalTitle = "Are you sure you want to archive?";
            this.assignEntry(id);
            this.machineService.send({
                type: "ARCHIVE_ENTRIES",
            });
        }
        showUnArchiveEntries(id) {
            this.modalTitle = "Are you sure you want to unarchive?";
            this.assignEntry(id);
            this.machineService.send({
                type: "UN_ARCHIVE_ENTRIES",
            });
        }
        showDeleteEntryModal(id) {
            this.assignEntry(id);
            this.modalTitle = "Are you sure you want to delete?";
            this.machineService.send({
                type: "DELETE_ENTRIES",
                isPageChanged: this.isLastpage,
            });
        }
        archivingEntries() {
            const isBulkSelected = !!this.state.hasTag("bulkSelected");
            const isAdvanceSearchAppliedWithBulkSelection = !!this.state.hasTag("bulkSelected") && !!this.state.hasTag("advanceSearch");
            var filters = [];
            var listFilters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            if (isAdvanceSearchAppliedWithBulkSelection) {
                Object.entries(this.columnListFilters).forEach(([key, value]) => {
                    listFilters.push({
                        listname: key,
                        listvalue: value,
                    });
                });
            }
            this.machineService.send({
                type: "ARCHIVING_ENTRIES",
                searchParams: { multiSearch: listFilters, search: filters },
                isAllSelected: isBulkSelected,
                entries: isAdvanceSearchAppliedWithBulkSelection || isBulkSelected ? [] : this.entries,
            });
        }
        unArchivingEntries() {
            this.machineService.send({
                type: "UN_ARCHIVING_ENTRIES",
                entries: this.entries,
            });
        }
        selectionChanged(params) {
            if (params.selectedRows.length === 0) {
                this.machineService.send({
                    type: "CANCEL_SELECTION",
                });
            }
            else {
                if (this.isAllSelected) {
                    this.machineService.send({
                        type: "BULK_SELECTION",
                    });
                }
                else {
                    this.machineService.send({
                        type: "BASIC_SELECTION",
                    });
                }
            }
        }
        clearGridColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
        }
        archiveMultiEntries() {
            this.entries = this.selectedEntries.map((entry) => entry.id);
            this.modalTitle = "Are you sure you want to archive?";
            this.machineService.send({
                type: "ARCHIVE_ENTRIES",
            });
        }
        unArchiveMultiEntries() {
            this.entries = this.selectedEntries.map((entry) => entry.id);
            this.modalTitle = "Are you sure you want to unarchive?";
            this.machineService.send({
                type: "UN_ARCHIVE_ENTRIES",
            });
        }
        deleteMultiEntries() {
            this.entries = this.selectedEntries.map((entry) => entry.id);
            this.modalTitle = "Are you sure you want to delete?";
            this.machineService.send({
                type: "DELETE_ENTRIES",
                isPageChanged: this.isLastpage,
            });
        }
        deletingEntries() {
            const isBulkSelected = !!this.state.hasTag("bulkSelected");
            const isAdvanceSearchAppliedWithBulkSelection = !!this.state.hasTag("bulkSelected") && !!this.state.hasTag("advanceSearch");
            var filters = [];
            var listFilters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            if (isAdvanceSearchAppliedWithBulkSelection) {
                Object.entries(this.columnListFilters).forEach(([key, value]) => {
                    listFilters.push({
                        listname: key,
                        listvalue: value,
                    });
                });
            }
            this.machineService.send({
                type: "DELETING_ENTRIES",
                searchParams: { multiSearch: listFilters, search: filters },
                isAllSelected: isBulkSelected,
                entries: isAdvanceSearchAppliedWithBulkSelection ? [] : this.entries,
            });
        }
        editEntry(id) {
            this.$router.push({ name: "EditEntry", params: { entryId: id } });
        }
        readPopover(rowId) {
            return rowId;
        }
        selectAllEntries() {
            this.machineService.send({
                type: "BULK_CONFIRMED",
            });
        }
        clearSelection() {
            var selectedEntries = this.$refs.ecgrid;
            selectedEntries.$refs["grid"].unselectAllInternal();
            this.machineService.send({
                type: "CANCEL_SELECTION",
            });
            this.entries = [];
        }
        showAdvanceSearchFlap() {
            let advancedSearchComponent = this.$refs["entryAdvanceSearch"];
            advancedSearchComponent.showAdvanceSearchFlap();
            this.machineService.send({
                type: "SHOW_ADVANCE_SEARCH_FLAP",
            });
        }
        showSaveSearchFlap() {
            this.machineService.send({
                type: "SHOW_SAVE_SEARCH",
            });
        }
        closeSearchFlap() {
            this.saveSearchItem.searchName = "";
            this.machineService.send({
                type: "CANCEL",
            });
        }
        showSearchList() {
            this.machineService.send({
                type: "GETTING_SEARCHES",
            });
        }
        closeSearchList() {
            this.selectedSearch = this.searches.find((f) => f.id == this.searchId);
            this.machineService.send({
                type: "CANCEL",
            });
        }
        deleteSearchItem(id) {
            this.machineService.send({
                type: "DELETING_SEARCH",
                searchId: id,
            });
        }
        shareSearchItem(item) {
            this.machineService.send({
                type: "SHARE_SEARCH",
                searchId: item.id,
                isSharable: !item.IsShared,
            });
        }
        applySavedSearch() {
            this.machineService.send({
                type: "APPLY_SEARCH",
            });
            var favorites = this.selectedSearch.entrySearch.columnFilters.filter((item) => item.name == "favorites");
            this.showFavorites = JSON.parse(favorites[0].value.toLowerCase());
            this.serverParams.columnFilters = {};
            this.selectedSearch.entrySearch.columnFilters = this.selectedSearch.entrySearch.columnFilters.filter((item) => item.name != "favorites");
            this.clearGridColumnFilters();
            if (this.selectedSearch.isAdvanceSearch) {
                let paramsConcat = this.selectedSearch.entrySearch.columnFilters.concat(this.selectedSearch.entrySearch.columnListFilters);
                var searchModel = new EntryAdvanceSearchModel();
                paramsConcat.forEach((obj) => {
                    if (Array.isArray(obj.listValue)) {
                        const guidItems = obj.listValue.map((value) => {
                            const guidItem = new GuidItemModel();
                            guidItem.id = value;
                            guidItem.value = this.getFlagNames(obj.listName, value);
                            return guidItem;
                        });
                        searchModel[obj.listName] = guidItems;
                    }
                    else {
                        searchModel[obj.name] = obj.value;
                    }
                });
                EntryModule.AssignAdvanceSearch(searchModel);
                this.notifyAdvanceSearchComponent();
                this.notifyAdvanceSearchToMachine();
                this.columnListFilters = [];
                this.selectedSearch.entrySearch.columnListFilters.forEach((filter) => {
                    this.columnListFilters[filter.listName] = filter.listValue;
                });
            }
            else {
                this.notifyMachineToBasicSearch();
                this.resetAdvanceSearch();
            }
            this.selectedSearch.entrySearch.columnFilters.forEach((item) => {
                this.serverParams.columnFilters[item.name] = item.value;
            });
            this.applyColumnFilter();
            this.initialSortBy.type = "";
            this.initialSortBy.field = "";
            this.serverParams.page = 1;
            this.initialSortBy = this.selectedSearch.entrySearch.sort;
            this.serverParams.sort = this.initialSortBy;
            this.loadItems();
        }
        notifyMachineToBasicSearch() {
            this.machineService.send({
                type: "BASIC_SEARCH",
            });
        }
        applyColumnFilter() {
            const columnFilters = this.selectedSearch?.entrySearch?.columnFilters || this.saveSearch?.entrySearch?.columnFilters;
            const ecgrid = this.$refs.ecgrid;
            if (!ecgrid || !columnFilters || !Array.isArray(columnFilters))
                return;
            const gridColumns = ecgrid.$refs?.grid?.$refs?.["table-header-primary"]?.$refs?.["filter-row"]?.columnFilters;
            if (!gridColumns)
                return;
            columnFilters.forEach((item) => {
                if (item.name !== "favorites") {
                    gridColumns[item.name] = item.value;
                }
            });
        }
        getFlagNames(flag, id) {
            let value;
            switch (flag) {
                case "tagsLists":
                    value = this.tags.find((x) => x.value == id).text;
                    break;
                case "categoriesLists":
                    value = this.categories.find((x) => x.value == id).text;
                    break;
                case "stateLists":
                    value = this.states.find((x) => x.value == id).text;
                    break;
                case "typeLists":
                    value = this.types.find((x) => x.value == id).text;
                    break;
                case "statusLists":
                    value = this.status.find((x) => x.value == id).text;
                    break;
            }
            return value;
        }
        applySearch(value) {
            this.serverParams.columnFilters = {};
            this.serverParams.page = this.initialPage;
            this.clearGridColumnFilters();
            if (value !== null) {
                for (const key in value) {
                    if (Array.isArray(value[key])) {
                        this.columnListFilters[key] = value[key].length > 0 ? value[key].map((item) => item.id) : [];
                    }
                    else {
                        this.serverParams.columnFilters[key] = value[key];
                    }
                }
            }
            this.machineService.send({
                type: "ADVANCE_SEARCH",
            });
            this.loadItems();
        }
        cancelSearch() {
            this.searchId = "";
            this.selectedSearch = new EntrySaveSearchModel();
            this.clearAdvanceSearch();
            this.machineService.send({
                type: "BASIC_SEARCH",
            });
        }
        reset() {
            if (this.isAnyFilterApplied) {
                this.clearAdvanceSearchData();
            }
            else {
                this.clearAdvanceSearch();
            }
            this.machineService.send({
                type: "SHOW_ADVANCE_SEARCH_FLAP",
            });
        }
        closeAdvanceSearch() {
            if (!this.previousState.hasTag("advanceSearch")) {
                this.machineService.send({
                    type: "BASIC_SEARCH",
                });
            }
            else {
                this.machineService.send({
                    type: "ADVANCE_SEARCH",
                });
            }
        }
        clearAdvanceSearch() {
            this.resetAdvanceSearch();
            this.loadItems();
        }
        resetAdvanceSearch() {
            this.clearAdvanceSearchData();
            this.serverParams.columnFilters = {};
        }
        clearAdvanceSearchData() {
            this.serverParams.columnListFilters = {};
            this.columnListFilters = [];
            var search = this.$refs.entryAdvanceSearch;
            search.isSearchIsApplied = false;
            this.entrySearch = new EntryAdvanceSearchModel();
            EntryModule.ClearAdvanceSearch();
        }
        ExportGenericReport() {
            this.GetDataToExportEntriesComponent();
            this.reportItems.reportTemplateId = this.genericReportId;
            const currentDate = new Date();
            var date = this.DateFormatForReportName(currentDate);
            this.send({
                type: "EXPORTING_ENTRIES",
                entryReport: this.reportItems,
                reportName: `${"Generic Report"}_${date}`,
            });
        }
        GetDataToExportEntriesComponent() {
            this.entries = this.selectedEntries.map((entry) => entry.id);
            const isBulkSelected = !!this.state.hasTag("bulkSelected");
            const isAdvanceSearchAppliedWithBulkSelection = !!this.state.hasTag("bulkSelected") && !!this.state.hasTag("advanceSearch");
            var filters = [];
            var listFilters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            if (isAdvanceSearchAppliedWithBulkSelection) {
                Object.entries(this.columnListFilters).forEach(([key, value]) => {
                    listFilters.push({
                        listname: key,
                        listvalue: value,
                    });
                });
            }
            this.reportItems.entrySelection.searchParams.search = filters;
            this.reportItems.entrySelection.searchParams.multiSearch = listFilters;
            this.reportItems.entrySelection.isAllSelected = isBulkSelected;
            this.reportItems.entrySelection.entries = isAdvanceSearchAppliedWithBulkSelection ? [] : this.entries;
        }
        ExportEntries() {
            this.GetDataToExportEntriesComponent();
            let entryReport = this.$refs["entryReportComponentRef"];
            entryReport.showModal();
        }
        sanitizeHtml(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const anchorTags = doc.querySelectorAll("a");
            anchorTags.forEach((tag) => {
                const href = tag.getAttribute("href");
                if (href && href.includes("/File/")) {
                    tag.addEventListener("click", async (event) => { });
                }
                else {
                    tag.setAttribute("target", "_blank");
                }
            });
            return doc.documentElement.innerHTML;
        }
        async handleLinkClick(event) {
            const target = event.target;
            if (target.tagName.toLowerCase() === "a") {
                const href = target.getAttribute("href");
                if (href && href.includes("/File/")) {
                    event.preventDefault();
                    const parts = href.split("/File/");
                    const uniqueIdentifier = parts[1];
                    try {
                        const res = await FileUploadModule.DownLoadFile(uniqueIdentifier);
                        console.log("File download successful", res);
                    }
                    catch (error) {
                        console.error("File download error", error);
                    }
                }
            }
        }
        initialize() {
            var value = EntryModule.gridParams;
            if (value != null) {
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                var favorites = value.columnFilters.filter((item) => item.name == "favorites");
                value.columnFilters.forEach((item) => {
                    this.serverParams.columnFilters[item.name] = item.value;
                });
                if (this.entryAdvanceSearchData != null) {
                    value.columnListFilters.forEach((filter) => {
                        this.columnListFilters[filter.listname] = filter.listvalue;
                    });
                }
                this.showFavorites = JSON.parse(favorites[0].value.toLowerCase());
                this.initialSortBy = value.sort;
            }
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams.columnFilters != null) {
                this.gridParams.columnFilters.forEach((item) => {
                    if (item.name !== "favorites") {
                        gridColumns[item.name] = item.value;
                    }
                });
            }
        }
        get gridParams() {
            return EntryModule.gridParams;
        }
        get saveSearch() {
            return EntryModule.saveSearch;
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "EditEntry" && from.name != "ViewEntry") {
                EntryModule.ClearGridParams();
                EntryModule.ClearAdvanceSearch();
            }
            if (from.name != "Automations") {
                EntryModule.ClearSaveSearch();
            }
            next();
        }
        setSaveSearch() {
            if (this.saveSearch != null) {
                var favorites = this.saveSearch.entrySearch.columnFilters.filter((item) => item.name == "favorites");
                this.showFavorites = JSON.parse(favorites[0].value.toLowerCase());
                this.serverParams.columnFilters = {};
                console.log(this.saveSearch.entrySearch.columnFilters, "ColumnFilters");
                this.saveSearch.entrySearch.columnFilters = this.saveSearch.entrySearch.columnFilters.filter((item) => item.name != "favorites");
                this.clearGridColumnFilters();
                if (this.saveSearch.isAdvanceSearch) {
                    const transformedListFilters = this.saveSearch.entrySearch.columnListFilters.map((item) => {
                        return {
                            name: item.listName,
                            value: JSON.stringify(item.listValue),
                        };
                    });
                    let paramsConcat = this.saveSearch.entrySearch.columnFilters.concat(transformedListFilters);
                    var searchModel = new EntryAdvanceSearchModel();
                    paramsConcat.forEach((obj) => {
                        try {
                            const parsed = JSON.parse(obj.value);
                            if (Array.isArray(parsed)) {
                                const guidItems = parsed.map((value) => {
                                    const guidItem = new GuidItemModel();
                                    guidItem.id = value;
                                    guidItem.value = this.getFlagNames(obj.name, value);
                                    return guidItem;
                                });
                                searchModel[obj.name] = guidItems;
                            }
                            else {
                                searchModel[obj.name] = obj.value;
                            }
                        }
                        catch {
                            searchModel[obj.name] = obj.value;
                        }
                    });
                    EntryModule.AssignAdvanceSearch(searchModel);
                    this.notifyAdvanceSearchComponent();
                    this.notifyAdvanceSearchToMachine();
                    this.columnListFilters = [];
                    this.saveSearch.entrySearch.columnListFilters.forEach((filter) => {
                        this.columnListFilters[filter.listName] = filter.listValue;
                    });
                }
                else {
                    this.notifyMachineToBasicSearch();
                    this.resetAdvanceSearch();
                }
                this.saveSearch.entrySearch.columnFilters.forEach((item) => {
                    this.serverParams.columnFilters[item.name] = item.value;
                });
                console.log(this.saveSearch.entrySearch.columnFilters, "ColumnFilters");
                this.applyColumnFilter();
                this.initialSortBy.type = "";
                this.initialSortBy.field = "";
                this.serverParams.page = 1;
                this.initialSortBy = this.saveSearch.entrySearch.sort;
                this.serverParams.sort = this.initialSortBy;
                this.loadItems();
            }
        }
        notifyAdvanceSearchComponent() {
            var search = this.$refs.entryAdvanceSearch;
            search.isSearchIsApplied = true;
        }
        notifyAdvanceSearchToMachine() {
            this.machineService.send({
                type: "ADVANCE_SEARCH",
            });
            var search = this.$refs.entryAdvanceSearch;
            search.overrideEntrySearch();
        }
        saveSearchedItems() {
            this.saveSearchItem.isAdvanceSearch = !!this.state.hasTag("advanceSearch");
            this.validate("entrySaveSearchObserver").then((res) => {
                if (res) {
                    this.machineService.send({
                        type: "SAVING_SEARCH",
                        entrySaveSearch: this.saveSearchItem,
                    });
                }
            });
        }
        reloadLists() {
            this.machineService.send({ type: "BASIC_SEARCH" });
            EntryModule.ClearGridParams();
            this.resetAdvanceSearch();
            this.loadItems();
        }
        rejectEntry(id) {
            this.machineService.send({ type: "REJECT_ENTRY" });
            this.rejectEntryId = id;
            this.showRejectEntry();
        }
        showRejectEntry() {
            let rejectEntry = this.$refs["rejectEntryRef"];
            rejectEntry.showModal();
        }
        rejectingEntry(reason) {
            this.rejectEntryReason = {
                id: this.rejectEntryId,
                value: reason,
            };
            this.machineService.send({ type: "REJECTING_ENTRY", rejectedReason: this.rejectEntryReason });
        }
        cancel() {
            this.rejectEntryReason = new GuidItemModel();
            this.machineService.send({ type: "CANCEL" });
        }
        approve(id) {
            this.machineService.send({ type: "APPROVING_ENTRY", entryId: id });
        }
        hideRejectModal() {
            let rejectEntry = this.$refs["rejectEntryRef"];
            rejectEntry.hideModal();
        }
        toggleShowFavorites() {
            this.showFavorites = !this.showFavorites;
            this.showFavoriteEntries();
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                if (this.previousState.matches("entries.operation.gettingEntryDeatils") && this.state.matches("entries.operation.gettingEntries") && this.saveSearch != null) {
                    this.setSaveSearch();
                }
                if (this.state.matches("entries.operation.gettingEntryDeatils") && this.gridParams) {
                    if (this.entryAdvanceSearchData != null) {
                        this.notifyAdvanceSearchComponent();
                    }
                    else {
                        this.assignColumnFilters();
                    }
                }
                if (this.state.matches("entries.operation.gettingEntries") && this.previousState.matches("entries.operation.rejectingEntry")) {
                    this.hideRejectModal();
                }
                if (this.state.matches("entries.operation.gettingEntries") && this.previousState.matches("entries.operation.gettingEntryDeatils")) {
                    const updateFilterDropdownItems = (column, field, values) => {
                        const itemType = column.find((x) => x.field === field);
                        if (itemType && itemType.filterOptions.filterDropdownItems.length === 0) {
                            itemType.filterOptions.filterDropdownItems = values;
                        }
                    };
                    const columns = this.isClient ? this.clientColumns : this.columns;
                    updateFilterDropdownItems(columns, "status", this.status);
                    updateFilterDropdownItems(columns, "type", this.types);
                    updateFilterDropdownItems(columns, "state", this.states);
                    updateFilterDropdownItems(columns, "tags", this.tags);
                    updateFilterDropdownItems(columns, "categories", this.categories);
                    if (this.entryAdvanceSearchData != null) {
                        this.notifyAdvanceSearchToMachine();
                    }
                }
                if (this.state.matches("entries.operation.loadedEntries")) {
                    this.totalCount = this.totalEntries;
                }
                if (this.state.matches("entries.operation.loadedEntries") && this.previousState.matches("entries.operation.gettingEntries")) {
                    this.initialPage = 1;
                }
                if (this.state.matches("entries.operation.loadedEntries") && this.previousState.matches("entries.operation.savingSearch")) {
                    this.saveSearchItem = new EntrySaveSearchModel();
                }
                if (this.state.matches("entries.operation.loadedSearches") && this.previousState.matches("entries.operation.gettingSearches")) {
                    if (this.selectedSearch.entrySearch) {
                        this.searchId = this.selectedSearch.id;
                        this.selectedSearch = this.searches.find((x) => x.id == this.selectedSearch.id);
                    }
                }
            });
        }
        categoryDescPopover(value) {
            return value.length > 10 ? value : null;
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    EntryListing = __decorate([
        Component({
            name: "EntryListing",
            components: {
                Layout,
                PageHeader,
                EcGrid,
                DeleteComponent,
                EcSelect,
                Switches,
                AdvanceSearchComponent,
                EntryReportComponent,
                simplebar,
                SectionLoader,
                ConfirmationDialog,
                RejectEntryComponent,
            },
        })
    ], EntryListing);
    return EntryListing;
})();
export default EntryListing;
